jQuery(function(){
  if ($('.hexagons-wrapper.monthly-updates').length > 0) {
    const baseUrl = $('#base-url').data('base-url');

    const dtSize = 80; // Hexagon size in desktop view;
    const data = $('#monthly-updates-json').data('json');

    // console.log('json data', data);

    const minHexCount = 8;
    let hexPerRowOdd;
    let hexPerRowEven;
    let hexSize;
    let viewState = [false, false, false, false, false];
    let timeout;

    $('.hexagon.mini.view-all').on('click', function(){
      const target = $($(this).data('target'));
      const index = target.data('index');

      viewState[index] = true;

      processRegion(target, true);
    });

    $('.hexagon.mini.view-less').on('click', function(){
      const target = $($(this).data('target'));
      const index = target.data('index');

      viewState[index] = false;

      processRegion(target, false);
    });

    function sortCountryCode(a, b) {
      return $(a).data('code') > $(b).data('code') ? 1 : -1;
    }

    function arrangeHexagons(hexSize, stageWidth) {
      hexPerRowOdd = Math.floor(stageWidth / hexSize); // Number of hexagons per row
      hexPerRowEven = hexPerRowOdd - 1; // Odd row has one less tile than even row

      // Loop each region to process and render hexagons
      $('.hexagons-wrapper.monthly-updates').each(function(index) {
        const viewAll = viewState[index];

        processRegion($(this), viewAll);
      });
    } // End of arrangeHexagons

    function processRegion(elm, viewAll) {
      elm.find('.hexagon.mini').css('opacity', 0);
      elm.find('.hexagon.mini.country').css('pointer-events', 'none');
      const hexagons = elm.find('.hexagon.mini');
      const hexViewAll = elm.find('.hexagon.mini.view-all');
      const hexViewLess = elm.find('.hexagon.mini.view-less');
      const totalHex = hexagons.length;

      let positiveNegativeHexs = elm.find('.hexagon.mini.posneg');
      let neutralHexs = elm.find('.hexagon.mini.neutral');
      let noReportHexs = elm.find('.hexagon.mini.no-report');

      let first8Hexs = [];
      let remainingHexs = [];
      let renderHexs = [];
      let sortedRenderHexs;

      // Show all hexagons
      if (viewAll) {
        hexViewAll.hide();
        renderHexs = [...positiveNegativeHexs, ...neutralHexs, ...noReportHexs];

        sortedRenderHexs = renderHexs.sort(sortCountryCode);

        renderHexagons([...sortedRenderHexs, hexViewLess], elm);
        // renderHexagons(renderHexs, elm);
      } else {
        hexViewLess.hide();

        // Check if hexs has minimum of 8
        if (positiveNegativeHexs.length < 8) {
          renderHexs = [...positiveNegativeHexs];

          let balance = minHexCount - positiveNegativeHexs.length;

          if (neutralHexs.length > 0) {
            $.each(neutralHexs, function(index) {
              if (balance > 0) {
                renderHexs.push($(this));
                balance--;
              }
            });
          }

          if (balance > 0) {
            for (let i=0; i<balance; i++) {
              renderHexs.push(noReportHexs[i]);
            }
          }

          renderHexs = [...renderHexs];
        } else {
          renderHexs = [...positiveNegativeHexs];
        }

        sortedRenderHexs = renderHexs.sort(sortCountryCode);

        renderHexagons([...sortedRenderHexs, hexViewAll], elm);
      }
    } // End of processRegion

    function renderHexagons(hexs, parent) {
      // console.log('renderHexagons hexs', hexs);
      // Positioning hexagons begin... //////////////////////////////////////////////////////////////////
      let row = 1;
      let col = 1;
      let offsetX = 0;

      // hexs.each(function(index) {
      $.each(hexs, function(index) {
        const hex = $(this);

          let endOfCurrentRowIndex = 0;

          // Determine which hexagon index to end current row
          for (i=1; i<=row; i++) {
            if (i % 2 === 0) { // Even
              endOfCurrentRowIndex+=hexPerRowEven;
            } else {
              endOfCurrentRowIndex+=hexPerRowOdd;
            }
          }

          // End of current row, current hexagon will begin from next row
          if (index >= endOfCurrentRowIndex) {
            row++;
            col = 1;

            // Hexagons on odd row is offset by translateX 50%
            if (row % 2 === 0) {
              offsetX = 50;
            } else {
              offsetX = 0;
            }
          }

          hex.css('width', hexSize + 'px');
          hex.css('top', (hexSize * (row - 1)) + 'px');
          hex.css('left', (hexSize * (col - 1)) + 'px');

          const offsetY = (row - 1) * 15;

          hex.css('transform', 'translate(' + offsetX + '%, -' + offsetY + '%)');

          hex.css('opacity', 0);

          hex.show();

          col++;
      }); // End of each

      setTimeout(() => {
        $.each(hexs, function(index) {
          const hex = $(this);
          hex.css('opacity', 1);
          hex.css('pointer-events', 'auto');
        });
      }, 100);

      $('.hexagon-country-code').css('font-size', hexSize * 0.2);

      // Re-calculate wrapper's height
      const wrapperHeight = hexSize + ((row - 1) * hexSize * 0.85);
      // Set wrapper div's height
      parent.height(wrapperHeight);
    } // End of renderHexagons

    $(window).on('resize', function() {
      clearTimeout(timeout);

      timeout = setTimeout(() => {
        // Get window width to determine hexagon's size
        const ww = $(window).width();
        const stageWidth = $('.hexagons-wrapper.monthly-updates').first().width();

        if (ww < 768) {
          hexSize = Math.floor(stageWidth / 7);
        } else {
          hexSize = dtSize;
        }

        arrangeHexagons(hexSize, stageWidth);
      }, 250);
    });

    // Trigger hexagons shuffle on first page load
    $(window).trigger('resize');


    function setOverlayContent(content) {
      $('.cop-mu .hhcp-content.flag').attr('src', 'https://flagcdn.com/w160/' + content.flagCountryCode.toLowerCase() + '.png');

      $('.cop-mu .hhcp-content.month').text(content.month + ' ' + content.year);
      $('.cop-mu .hhcp-content.country').text(content.country);

      let trimSummary;

      if (content.summary !== null && content.summary !== '') {
        trimSummary = content.summary.split(" ").splice(0, 20).join(" ") + '...';
      } else {
        trimSummary = '';
      }

      $('.cop-mu .hhcp-content.summary').text(trimSummary);
      $('.cop-mu .hhcp-content.permalink').attr('href', content.countryProfilePermalink);

      if (content.attributes === null) {
        $('.hhcp-content.attributes').hide();
      } else {
        attributesRef = [];
        attributesRef[0] = { 'code' : 'rg', 'img' : 'representative-government', 'value' : content.attributes.representative_government };
        attributesRef[1] = { 'code' : 'fr', 'img' : 'fundamental-rights', 'value' : content.attributes.fundamental_rights };
        attributesRef[2] = { 'code' : 'cg', 'img' : 'checks-on-government', 'value' : content.attributes.checks_on_government };
        attributesRef[3] = { 'code' : 'ia', 'img' : 'impartial-administration', 'value' : content.attributes.impartial_administration };
        attributesRef[4] = { 'code' : 'pe', 'img' : 'participatory-engagement', 'value' : content.attributes.participatory_engagement };

        $.each(attributesRef, function() {
          $('.cop-mu .hhcp-content.gsod-attribute.' + this.code).parent().hide();

          if (this.value !== 'None' && this.value !== undefined) {
            $('.cop-mu .hhcp-content.gsod-attribute.' + this.code).attr('src', baseUrl + 'themes/custom/gsod/src/assets/icons/icon-' + this.img + '-' + this.value.toLowerCase() + '.svg');
            $('.cop-mu .hhcp-content.gsod-attribute.' + this.code).parent().show();
          }
        });
        $('.hhcp-content.attributes').show();
      }
    }

    $('.hexagon.mini').on('mouseenter', function(){    
      const id = $(this).data('id');
      const content = data[id];

      if ($(this).hasClass('view-all') || $(this).hasClass('view-less')) {
        return;
      }

      if (data[id] === undefined) {
        $(this).addClass('pointer-events-none');
      }
    });

    $('.hexagon.mini').on('click', function(){
      const parent = $(this).parent().parent().parent();
      const panel = $('#country-overlay-panel-mu').detach();

      parent.append(panel);
      
      const id = $(this).data('id');
      const content = data[id];
      const loading = $('#country-overlay-panel-mu .loading');

      if (data[id] === undefined) {
        // $(this).addClass('pointer-events-none');
       $('#country-overlay-panel-mu').removeClass('active');
       return;
      }

      if (panel.hasClass('active')) {
        loading.fadeIn(300, function() {
          setOverlayContent(content);
          loading.fadeOut(300);
        });
      } else {
        setOverlayContent(content);
        setTimeout(() => {
          panel.addClass('active');
        }, 100);
      }
    });

    $('.button-close-country-panel-mu').on('click', function(){
      $('#country-overlay-panel-mu').removeClass('active');
    });
  }
});